const locale = require('./reportsSummary.i18n.json');

/*@ngInject*/
const ReportsSummaryController = function ($scope, $rootScope, $timeout, $stateParams, reportMediator, submissionConstant, submissionUtil, coreConstant, coreMediator, dateUtil, appTypeConfigurationModel) {

    $scope.i18n = locale;

    $scope.viewModel = {
        isLoading: true,
        reports: []
    };

    function loadReports() {
        $scope.viewModel.isLoading = true;
        reportMediator.getReportList($stateParams.submissionId).then(function (reports) {
            $scope.viewModel.reports = reports;
            $scope.viewModel.isLoading = false;
        });
    }

    $scope.openReport = function (report) {
        $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, report.objectUri);
    };

    $scope.getIdentifier = function (report) {
        return _.camelCase(report.name);
    };

    loadReports();
};

angular.module('gw-um-submission')
    .controller('reportsSummaryController', ReportsSummaryController);
